import React, { Component } from "react";
import Slider from "react-slick";
import { portfolioSlick2 } from "../../../page-demo/script";
import {Link} from "react-router-dom";
import { LanguageContext } from "../../../context/LanguageContext";
import translations from "../../../translations";

const singleDemo = [
    {
        url: 'https://mass-portal.com/',
        imageUrl: 'dark-main-demo.png',
        title: 'MassPortal',
        description: 'MassPortal Arabic Taxation Portal: Your comprehensive online platform for simplified and efficient Arabic taxation management..',
        label: 'Fintech'
    },
    {
        url: 'https://mass-billing.web.app/',
        imageUrl: 'massbilling-480x470.png',
        title: 'MassBill',
        description: 'MassBill Arabic ERP System: Streamline your business operations with our powerful and user-friendly Arabic Enterprise Resource Planning solution..',
        label: 'Fintech'
    },
     {
        url: 'https://mass-contracts.web.app/mc-intro',
        imageUrl: 'mass-contractsj-480x470.png',
        title: "Mass Contracts",
        description: "Mass Contracts: Smart contract and agreement management platform.",
        label: 'Fintech'
    },
    {
        url: 'https://massbill-hasibat.web.app/',
        imageUrl: 'masshasibat-480x470.png',
        title: 'Mass Hasibat',
        description: 'Hasibat Arabic Free Financial Calculators: Empowering you with a suite of convenient and reliable Arabic financial calculators..',
        label: 'Fintech'
    },
   
    {
        url: 'https://massaii.web.app/',
        imageUrl: 'massai-480x470.png',
        title: 'MassAi',
        description: 'MassAi Arabic Free AI Image Creation: Unleash your creativity with our cutting-edge AI-powered image creation tools in Arabic..',
        label: 'AI'
    },
      
    {
        url: 'https://levaant.web.app/',
        imageUrl: 'levant-480x470.png',
        title: 'Levant',
        description: 'Levant: AI-powered social media for healthcare, connecting professionals and empowering patients in a digital community..',
        label: 'Social Media'
    },
    {
        // url: 'https://massres.work/',
        url: 'https://mass-res.web.app/',
        imageUrl: 'massRess-480x470.png',
        title: 'Massres',
        description: 'MassRes: The social media platform connecting freelancers and job seekers in the pursuit of opportunities..',
        label: 'Social Media'
    },
    
    {
        // url: 'https://math-ac2.firebaseapp.com/',
        url: 'https://math-ac.com/',
        imageUrl: 'mathac-480x470.png',
        title: 'Math Academy',
        description: 'Math Academy: Unlock the world of web coding through our comprehensive and interactive online courses..',
        label: 'Dev'
    },
    
    {
        url: 'https://earthsense-morroco-dev.web.app/earthsense/',
        imageUrl: 'earthsense-480x470.png',
        title: 'Earth Sense',
        description: 'EarthSense: Your trusted agricultural consulting partner in Morocco, providing expertise and solutions for sustainable farming..',
        label: 'Commercial'
    },
    
    {
        url: 'https://agrima-dev.web.app/',
        imageUrl: 'agrima-480x470.png',
        title: 'Agrima',
        description: 'Agrima: A leading enterprise holding company, driving growth and innovation across diverse industries..',
        label: 'Commercial'
    },
    {
        url: 'https://bostani-me.web.app/',
        imageUrl: 'bostani-480x470.png',
        title: 'Bostani',
        description: 'Bostani: The social media platform connecting agriculture enthusiasts, fostering knowledge sharing and community engagement.',
        label: 'Social Media'
    },
    {
        url: 'https://massarwe.com/',
        imageUrl: 'massarweh-480x470.png',
        title: 'Massarwe',
        description: 'Massarwe: Empowering businesses with cutting-edge fintech consulting services for strategic growth and financial innovation..',
        label: 'Commercial'
    },
    {
        url: 'https://mass-dev-cs.web.app/',
        imageUrl: 'massdev-480x470.png',
        title: 'MassDev- Arabic',
        description: 'MassDev: Your one-stop destination for professional website development services, delivering stunning and functional online experiences..',
        label: 'Commercial'
    },
    {
        url: 'https://zayn-steak-and-grillshow.web.app/index.html',
        imageUrl: 'zains-480x740.png',
        title: "ZAYN'S",
        description: "'Zayn's creates dishes full of flavor, we pride ourselves on using fresh, sustainable ingredients in new and delectable ways.",
        label: 'Commercial'
    },
    
    {
        url: 'https://almihaniyoun-pro.web.app/',
        imageUrl: 'almihaniyoun-480x470.png',
        title: "Bunat",
        description: "Bunat: Professional services and solutions for your business needs.",
        label: 'Commercial'
    },
    {
        url: 'https://albushra-ai.web.app/',
        imageUrl: 'albushra-480x470.png',
        title: "Al Bushra AI",
        description: "Al Bushra AI: Innovative AI-powered solutions for modern businesses.",
        label: 'AI'
    },
    {
        url: 'https://immobilier-ndjamena.web.app/',
        imageUrl: 'immobilier-ndjamena-480x470.png',
        title: "Immobilier N'Djamena",
        description: "Immobilier N'Djamena: Real estate solutions and property management services.",
        label: 'Commercial'
    },
    {
        url: 'https://mass-tec.web.app/',
        imageUrl: 'mass-tec-480x470.png',
        title: "Mass Tec",
        description: "Mass Tec: Technology solutions and digital transformation services.",
        label: 'Dev'
    },
    
    {
        url: 'https://muqadimah-ibenkhaldoun.web.app/',
        imageUrl: 'muqadimah-ibenkhaldoun-480x470.png',
        title: "Muqadimah Ibn Khaldoun",
        description: "Muqadimah Ibn Khaldoun: Educational and cultural platform.",
        label: 'Dev'
    },
    {
        url: 'https://wahy-alqalam.web.app/',
        imageUrl: 'wahy-alqalam-480x470.png',
        title: "Wahy Al Qalam",
        description: "Wahy Al Qalam: Creative writing and literary platform.",
        label: 'Commercial'
    },
    {
        url: 'https://alnaqdan.com/',
        imageUrl: 'alnaqdan-480x470.png',
        title: "Al Naqdan",
        description: "Al Naqdan: Financial and economic insights platform.",
        label: 'Fintech'
    },
    
    {
        url: 'https://omrimassarwe.com/',
        imageUrl: 'omri-480x470.png',
        title: "Omri Massarwe",
        description: "Photographer & Filmmaker Based In Jerusalem.",
        label: 'Commercial'
    },
     {
        url: 'https://fintrack.expert/',
        imageUrl: 'fintrack-480x470.png',
        title: 'Fintrack',
        description: 'Fintrack: Designed for professionals and accessible to everyone. Check your salary statements, retirement funds, and all your financial data.',
        label: 'Fintech'
    },
     {
        url: 'https://mass-quickscan.web.app/',
        imageUrl: 'quickscan-480x470.png',
        title: 'Quick Scan',
        description: 'يمكنك فحص أي باركود من خلال ادخال المعلومات: نص أو رقم',
        label: 'Fintech'
    }, {
        url: 'https://mass-prj.web.app/',
        imageUrl: 'mass-prj-480x470.png',
        title: 'Mass Project',
        description: 'MassProject',
        label: 'Fintech'
    },
     
    {
        url: 'https://caraj-dev.firebaseapp.com/pages/login',
        imageUrl: 'caraj-480x470.png',
        title: "Caraj",
        description: "Caraj: Comprehensive management and logistics platform.",
        label: 'Commercial'
    },
    {
        url: 'https://api-massarwe.web.app/',
        imageUrl: 'api-massarwe-480x470.png',
        title: 'Api.massarwe',
        description: 'This portal grants you access to Massarwe APIs — simple, secure, and powerful. Interface with the digital realm through our quantum-encrypted data channels.',
        label: 'Fintech'
    },
 
  
    {
        url: 'https://universal-interface.co',
        imageUrl: 'universal-interfacej-480x470.png',
        title: "Universal Interface",
        description: "Universal Interface: Advanced interface solutions for modern applications.",
        label: 'Dev'
    },
    {
        url: 'https://edu-mass.web.app/',
        imageUrl: 'edumass-480x470.png',
        title: "EduMass",
        description: "منصة التعليم الذكية المدعومة بالذكاء الاصطناعي لمساعدة المعلمين في إنشاء المحتوى التعليمي، وتخطيط الدروس، وإنشاء الاختبارات، وأكثر من ذلك بكثير.",
        label: 'Commercial'
    },  {
        url: 'https://omricore.com/',
        imageUrl: 'omricore-480x470.png',
        title: "OmriCore",
        description: "OmriCore is a visual storytelling agency rooted in a decade of experience, purpose, and passion.",
        label: 'Commercial'
    },
    {
        url: 'https://vivmana.com/',
        imageUrl: 'vivmana-480x470.png',
        title: "VIVMANA",
        description: "VIVMANA: Premium beauty and cosmetic products and services designed to enhance your natural beauty and boost your confidence.",
        label: 'Commercial'
    }, {
        url: 'https://massbook.co/',
        imageUrl: 'massbook-480x470.png',
        title: "MassBook",
        description: "MassBook: Social networking and community platform.",
        label: 'Social Media'
    },
    {
        url: 'https://mass-prtg.web.app/',
        imageUrl: 'mass-prtg-480x470.png',
        title: "Mass-Prtg",
        description: "PRTGMass is an intelligent React-based platform that connects seamlessly with PRTG Network Monitor to collect, analyze, and visualize network performance data in real time.",
        label: 'Commercial'
    },
   
    {
        url: 'https://juabeh-hospital.web.app/',
        imageUrl: 'juabeh-hospital-480x470.png',
        title: "Juabeh Hospital",
        description: "Juabeh Hospital: Healthcare management and patient services platform.",
        label: 'Commercial'
    },
    {
        url: 'https://fadi-dahabreh.web.app/',
        imageUrl: 'fadi-dahabreh-480x470.png',
        title: "Fadi Dahabreh",
        description: "Fadi Dahabreh: Professional portfolio and services platform.",
        label: 'Commercial'
    },
    {
        url: 'https://subhicuts-dev.web.app/',
        imageUrl: 'subhicuts-480x470.png',
        title: "Subhi Cuts",
        description: "Subhi Cuts: Professional grooming and styling services.",
        label: 'Commercial'
    },
 
    
    {
        url: 'https://motken-ai.web.app/',
        imageUrl: 'mutken-480x470.png',
        title: "Motken AI",
        description: "احصل على نسخ مفرغة دقيقة لفيديوهات يوتيوب وتيك توك باللغة العربية باستخدام أحدث تقنيات الذكاء الاصطناعي.",
        label: 'Commercial'
    },
 
    // {
    //     url: '#',
    //     imageUrl: 'mirath-480x470.png',
    //     title: "Mirath",
    //     description: "Mirath: Coming soon.",
    //     label: 'Commercial'
    // },


   
]
const PortfolioList = [
    {
        image: 'image-1',
        category: 'Development',
        title: ' Getting tickets to the big show'
    },
    {
        image: 'image-2',
        category: 'Development',
        title: ' Getting tickets to the big show'
    },
    {
        image: 'image-3',
        category: 'Development',
        title: ' Getting tickets to the big show'
    },
    {
        image: 'image-4',
        category: 'Development',
        title: ' Getting tickets to the big show'
    },
    {
        image: 'image-3',
        category: 'Development',
        title: ' Getting tickets to the big show'
    },
    {
        image: 'image-4',
        category: 'Development',
        title: ' Getting tickets to the big show'
    }
]

class Portfolio extends Component{
    static contextType = LanguageContext;

    render(){
        const { language } = this.context;
        const t = translations[language];

        return(
            <React.Fragment>
                <div className="portfolio-wrapper">
                    {/* <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <h2>{title}</h2>
                                    <p>{description}</p>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="portfolio-slick-activation  mt_sm--40" >
                        <Slider {...portfolioSlick2}>
                            {singleDemo.map((value , index) => (
                                <div className="portfolio" key={index}>
                                    <div className="thumbnail-inner">
                                        <img src={`/assets/images/preview/${value.imageUrl}`} alt={value.title} className="w-100"/>
                                    </div>
                                    <div className="content">
                                        <div className="inner text-center">
                                            <p>{value.label}</p>
                                            <h4 className="title"><a href={value.url} target="_blank" rel="noopener noreferrer">{value.title}</a></h4>
                                            <div className="portfolio-button">
                                                <a className="rn-btn" href={value.url} target="_blank" rel="noopener noreferrer">{t.homepage.latestProjects?.viewProject || 'View Project'}</a>
                                            </div>
                                        </div>
                                    </div>
                                    <a className="link-overlay" href={value.url} target="_blank" rel="noopener noreferrer" ></a>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default Portfolio;